import Template from "configurator-studio-arkitekter-components/dist/common/components/Template";

export default Template;
